// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisplayCards_wrapper__9yUiX","title":"DisplayCards_title__KYO83","content":"DisplayCards_content__nu_IB","column":"DisplayCards_column__1WfUM"};